<template>
  <v-app id="inspire">
    <the-loading-overlay :value="loading"/>
    <v-dialog
      v-model="showTermsDialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      persistent
      maxWidth="1200"
    >
      <v-card>
        <v-card-title class="title justify-center">Terms of Service</v-card-title>
        <v-card-text
            :class="{'iframe-area': !$vuetify.breakpoint.smAndDown}"
            v-bind:style="termsContentStyles">
          <iframe
            class="terms"
            :src="privacyPolicyUrl">
          </iframe>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="primary" @click="acceptTerms()">Accept</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <lightbox/>
    <session-modal/>
    <unauthorized-modal/>
    <v-navigation-drawer v-if="!hideSidebar" v-model="isDrawerOpen" app width="240">
      <v-list class="py-0">
        <v-btn
          @click="closeDrawer"
          v-if="isDrawerOpen && $vuetify.breakpoint.smAndDown"
          style="top: 5px; right: 5px;"
          top right
          small
          absolute
          fab :style="{ 'background-color': themeAccent, 'color': themeWhite }">
          <v-icon>close</v-icon>
        </v-btn>
        <v-layout class="logo-background py-0 justify-center" :style="{ 'background-color': themePrimary }">
          <img class="logo align-center" height="90" :src="siteCornerImage">
        </v-layout>
        <v-divider/>
        <v-list-tile ripple accent to="/" v-if="isLoadboardEnabled">
          <v-list-tile-action>
            <v-icon>search</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Search {{ $t('components.loadboard') }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile class="new-load-tile" v-if="signedIn" ripple to="/post-load">
          <v-list-tile-action>
            <v-btn small fab
                   :style="{ 'background-color': themeAccent, 'color': themeWhite}">
              <v-icon>add</v-icon>
            </v-btn>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Add New Load</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <br>

        <v-layout column v-if="userProfile.driverProfile">
          <v-list-tile slot="activator" class="list-hotfix" ripple to="/my-loads">
            <v-list-tile-action>
              <v-icon>assignment_ind</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>My Assigned Loads</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-layout>
        <v-list-group
          v-if="signedIn"
          value="false"
          v-for="(company, index) in companiesWithOptions"
          :key="index"
        >
          <v-list-tile slot="activator" :key="company.companyId" class="list-hotfix">
            <v-list-tile-title>
              <b>{{company.companyDisplayName}}</b>
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile
            v-for="option in company.options"
            @click="closeDrawer"
            ripple
            :to="option.link"
            :key="option.title"
          >
            <v-list-tile-action>
              <v-icon>{{option.icon}}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ option.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>

        <v-list-group v-if="isLtnAdmin">
          <v-list-tile slot="activator" class="list-hotfix">
            <v-list-tile-action>
              <v-icon>apps</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Admin Tools</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile class="cursor-pointer list-hotfix" ripple to="/companies/new">
            <v-list-tile-action>
              <v-icon>add_circle</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>New Company</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile class="cursor-pointer list-hotfix" ripple to="/companies">
            <v-list-tile-action>
              <v-icon>business</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>All Companies</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile class="cursor-pointer list-hotfix" ripple to="/untethered">
            <v-list-tile-action>
              <v-icon>business</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Untethered Listings</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile class="cursor-pointer list-hotfix" ripple to="/users">
            <v-list-tile-action>
              <v-icon>people</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Users</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
      </v-list>
      <v-layout column>
        <template v-if="signedIn">
          <v-layout
            class="py-3 primary cursor-pointer"
            row
            align-center
            @click="$router.push({ name: 'profile' })"
          >
            <v-flex sm2 class="ml-2">
              <v-avatar size="30">
                <v-icon>account_circle</v-icon>
              </v-avatar>
            </v-flex>
            <v-flex sm10 class="white--text">
              <b>{{userProfile.name || userProfile.contactEmail}}</b>
            </v-flex>
          </v-layout>

          <v-layout v-if="!isNonceUser"
                    class="primary px-2 pb-3"
                    row align-center>
            <v-flex sm2>
              <v-icon>settings</v-icon>
            </v-flex>
            <v-flex
              sm10
              class="white--text cursor-pointer"
              @click="$router.push({ name: 'notification-settings' })"
            >
              <b>Notification Settings</b>
            </v-flex>
            <v-spacer/>
          </v-layout>

          <v-layout class="primary px-2 pb-1 cursor-pointer" row align-center @click="signOut()">
            <v-flex sm2>
              <v-icon>exit_to_app</v-icon>
            </v-flex>

            <v-flex sm10 class="white--text">
              <b>Logout</b>
            </v-flex>

            <v-spacer/>
          </v-layout>

          <v-list-tile ripple accent to="/refer" v-if="signedIn">
            <v-list-tile-action>
              <v-icon>person_add</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Refer a Friend</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile
            ripple
            accent
            target="_blank"
            :href=contactUsLink
          >
            <v-list-tile-action>
              <v-icon>contact_support</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('components.contact-us.label') }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
        <template v-else>
          <v-layout class="white--text primary py-3 px-2">
            <v-flex class="cursor-pointer" @click="signIn">
              <b>Log In</b>
            </v-flex>
            <v-flex class="cursor-pointer" @click="$router.push({ name: 'onboard' })">
              <b>Sign Up</b>
            </v-flex>
          </v-layout>

          <v-list-tile
            ripple
            accent
            target="_blank"
            :href=contactUsLink
          >
            <v-list-tile-action>
              <v-icon>contact_support</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('components.contact-us.label') }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-layout>
    </v-navigation-drawer>

    <v-content>
      <v-snackbar
        v-model="notificationStatus"
        :value="notification.show"
        :type="notification.type"
        :timeout="notification.timeout"
        top
        :color="notification.color"
      >
        {{notification.message}}
        <v-btn flat @click="$store.dispatch('applications/hideNotification')">Close</v-btn>
      </v-snackbar>
      <v-container fluid class="pb-0">
        <router-view/>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import API from '@/api';
import URI from 'urijs';
import moment from 'moment';

import firebase from 'firebase';
import SessionModal from '@/components/SessionModal';
import { mapState, mapGetters } from 'vuex';
import TheLoadingOverlay from '@/components/TheLoadingOverlay';

import Lightbox from '@/components/Lightbox';
import UnauthorizedModal from '@/components/UnauthorizedModal';

import { hasFinancialPermission } from '@/store/permissions';
import pluginMixin from '@/mixins/pluginMixin';

export default {
  name: 'App',
  components: {
    SessionModal,
    TheLoadingOverlay,
    Lightbox,
    UnauthorizedModal,
  },
  mixins: [
    pluginMixin,
  ],
  watch: {
    'notification.show': function (val) {
      this.notificationStatus = val;
    },
    notificationStatus(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.$store.dispatch('applications/hideNotification');
      }
    },
    userProfile() {
      this.refreshQbInfo();
    },
  },
  computed: {
    ...mapState('profiles', ['userProfile']),
    ...mapGetters('profiles', ['companiesWithOptions', 'isLtnAdmin']),
    ...mapGetters('applications', ['signedIn', 'isAnonymous', 'isNonceUser']),
    ...mapState('applications', ['loading', 'notification']),
    isDrawerOpen: {
      get() {
        return this.$store.state.applications.isDrawerOpen;
      },
      set(isDrawerOpen) {
        if (isDrawerOpen !== this.isDrawerOpen) {
          this.$store.dispatch('applications/toggleDrawer');
        }
      },
    },
    termsContentStyles() {
      if (this.$vuetify.breakpoint.smAndDown) {
        const height = this.$vuetify.breakpoint.height - 110;
        return { height: `${height}px` };
      }

      return {};
    },
    hideSidebar() {
      return this.$route.meta.hide_sidebar;
    },
    themePrimary() {
      return `var(--primary)`;
    },
    themeWhite() {
      return `var(--white)`;
    },
    themeAccent() {
      return `var(--accent)`;
    },
    contactUsLink() {
      return this.currentActivePlugins.hq.contact_info.contact_us_href;
    },
    siteCornerImage() {
      return this.currentActivePlugins.hq.contact_info.site_corner_image;
    },
    privacyPolicyUrl() {
      return this.currentActivePlugins.hq.privacy_policy;
    },
  },
  methods: {
    closeDrawer() {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.isDrawerOpen = false;
      }
    },
    signIn() {
      this.$store.dispatch('applications/showSessionModal');
    },
    signOut() {
      this.$store.dispatch('applications/signOut');
    },
    async loginWithToken() {
      this.$bus.$off('doTokenLogin', this.loginWithToken);
      const searchParams = URI().search(true);

      try {
        const response = await API.user.viewLoadWithNonce({ ln: searchParams.ln });
        const user = await firebase.auth().signInWithCustomToken(response.data.jwt);
        const isAnonymous = user.isAnonymous;
        this.$store.dispatch('applications/setCurrentUser', { currentUser: { isAnonymous, nonceUser: true } });
        await this.$store.dispatch('profiles/getUserProfile');
        this.$bus.$emit('loginWithNonce');
      } catch (e) {
        this.$router.push({ name: 'error401' });
      }
    },
    checkTermsAcceptance() {
      if (
        firebase.auth().currentUser &&
        !firebase.auth().currentUser.isAnonymous &&
        !localStorage.getItem('terms_accepted')
      ) {
        this.showTermsDialog = true;
      }
    },
    acceptTerms() {
      localStorage.setItem('terms_accepted', 'true');
      this.showTermsDialog = false;
    },
    refreshQbInfo() {
      if (this.userProfile.companyAccounts) {
        this.userProfile.companyAccounts.forEach((company) => {
          if (hasFinancialPermission(company.companyPermissions) &&
            company.quickbooksConnectedUntil &&
            moment(company.quickbooksConnectedUntil, moment.ISO_8601).isAfter(moment())) {
            this.$store.dispatch('quickbooks/reloadCompanyInfo', company.companyId);
          }
        });
      } else {
        this.$store.dispatch('quickbooks/clear');
      }
    },
    initVersionListener() {
      const dbRef = firebase.database().ref('version/tag');
      dbRef.once('value').then((initialVal) => {
        // listen changes
        localStorage.setItem('currentVersion', initialVal.val());

        dbRef.on('value', (snapshot) => {
          if (localStorage.getItem('currentVersion') !== snapshot.val()) {
            this.$confirm('A new version is available. Do you want to reload the page?',
              { color: 'warning',
                icon: 'warning',
                title: 'Warning',
              }).then((confirm) => {
              if (confirm) {
                location.reload();
              }
            });
          }
        });
      });
    },
    switchLocale() {
      this.$store.dispatch('applications/switchLocale');
    },
  },
  data: () => ({
    drawer: null,
    notificationStatus: false,
    showTermsDialog: false,
  }),
  destroyed() {
    this.$bus.$off('authStateChanged', this.checkTermsAcceptance);
  },
  created() {
    this.initVersionListener();
    this.$bus.$on('authStateChanged', this.checkTermsAcceptance);

    const searchParams = URI().search(true);
    if (searchParams.ln) {
      this.loginWithToken();
      this.$bus.$on('doTokenLogin', this.loginWithToken);
    } else {
      this.checkTermsAcceptance();
      this.refreshQbInfo();
    }
  },
};
</script>


<style scoped>
.logo {
  margin: 16px;
}
</style>

<style>
.container {
  max-width: 120vw;
  margin: 0 0;
}
.v-content {
  background-color: var(--background)
}


.opened-date-picker .v-dialog__content {
  display: -webkit-box !important;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
}

.list-hotfix {
  flex: 1 1 auto !important;
  overflow: hidden;
}
.cursor-pointer {
  cursor: pointer;
}
.logo-background {
  background-color: var(--white);
  width: 100%;
  align: center;
}

.picker {
  border-bottom-color: rgba(0, 0, 0, 0.42);
  border-bottom-width: thin;
  border-bottom-style: solid;
  width: 100%;
  margin-top: 10px;
  font-family: Roboto, sans-serif;
  font-size: 16px;
}

.v-input--selection-controls {
  margin-top: 0;
}

.vdatetime.disabled input {
  color: rgba(0, 0, 0, 0.38);
}

.vdatetime.bid-picker {
  width: 100%;
}

.bid-picker .picker {
  padding-bottom: 6px;
}

.vdatetime-time-picker__list--minutes {
  display: none;
}

.vdatetime-time-picker__with-suffix .vdatetime-time-picker__list {
  width: 50%;
}
.vdatetime {
  width: 90%;
}

table.v-table {
  min-width: 1200px;
}

.mobile-title {
  padding-top: 16px;
  padding-bottom: 8px;
}

iframe.terms {
  border: 0;
  width: 100%;
  height: 100%;
}

.iframe-area {
  height: 60vh;
}

.mobile-iframe {
  height: 450px;
}

.popover {
  top: 0;
  left: 0;
  z-index: 1060;
  max-width: 276px;
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: .875rem;
  word-wrap: break-word;
  background-color: var(--white);
  background-clip: padding-box;
  border: 1px solid rgba(0,0,0,.2);
  border-radius: .3rem;
}

.bs-popover-auto[x-placement^=top]>.arrow, .bs-popover-top>.arrow {
  bottom: calc(-.5rem + -1px);
}

.popover .arrow {
  width: 1rem;
  height: .5rem;
  margin: 0 .3rem;
}

.popover, .popover .arrow {
  position: absolute;
  display: block;
}

.popover-header {
  padding: 0;
  margin-bottom: 0;
  font-size: 1rem;
  background-color: var(--background);
  border-bottom: 1px solid var(--background);
  border-top-left-radius: calc(.3rem - 1px);
  border-top-right-radius: calc(.3rem - 1px);
  text-align: right;
}

.popover-body {
  padding: .5rem .75rem;
  color: var(--accent);
  font-size: 14px;
  font-family: Roboto, sans-serif;
}
.month-picker-container {
  width: initial !important;
}

.unassigned {
  border-left: 3px red solid;
}

.assigned {
  border-left: 3px var(--success) solid;
}

.assigned_not_accepted {
  border-left: 3px var(--info) solid;
}

.not_mine {
  border-left: 3px var(--warning) solid;
}

.vendor_assigned {
  border-left: 3px var(--success) solid;
}

.new-load-tile {
  padding-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue